@if (result.fieldValue) {
  <form
    #form="ngForm"
    (focusout)="!form.invalid && onChangeResult()"
    class="detail-result-number-field-value">
    @if (result.fieldValue.inspectionElementFieldType === fieldTypes.Number) {
      <form-control invalidKey="InvalidNumber">
        <input
          name="numberValue"
          [(ngModel)]="result.fieldValue.numberValue"
          type="number"
          [disabled]="readonly" />
        @if (displayRemark) {
          <app-detail-result-remark
            class="btn-ellipsis-link-after-dropdown"
            [result]="result"
            (remarkChange)="onChangeRemark()"
            [readonly]="readonly"></app-detail-result-remark>
        }
      </form-control>
    }
  </form>
}
